/**
 * Дата по Москве: «10 октября 2026 г.»; с `{ year: false }` — «10 октября».
 *
 * bit-auth отдаёт время в UTC без «Z» (datetime.utcnow через pydantic), а браузер
 * прочёл бы такую строку как местное время и около полуночи сдвинул бы день —
 * в кабинете и в админке одно и то же согласие показывалось бы разными датами.
 * Строка без смещения считается UTC; одна дата «YYYY-MM-DD» (редакция документа)
 * берётся как есть — по стандарту она и так UTC-полночь.
 */
export function formatMoscowDate(value, { year = true } = {}) {
  if (!value) return '—';
  const s = String(value);
  const iso = /Z$|[+-]\d\d:?\d\d$/.test(s) || s.length === 10 ? s : `${s}Z`;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '—';
  return d.toLocaleDateString('ru-RU', {
    day: 'numeric', month: 'long', ...(year ? { year: 'numeric' } : {}), timeZone: 'Europe/Moscow',
  });
}
